import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Configuration } from '../../Configuration';
import { SalesService } from './../sales-forecast/sales-service.service';
import { DecimalPipe, DatePipe } from '@angular/common';
import { Angular2Csv } from 'angular2-csv/Angular2-csv';
import { MapsAPILoader } from '@agm/core';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import * as moment from 'moment';
import { AgmMap } from '@agm/core';
import { GoogleMapsAPIWrapper } from '@agm/core';


@Component({
  selector: 'app-store-view',
  templateUrl: './store-view.component.html',
  styleUrls: ['./store-view.component.css']
})

export class StoreViewComponent implements OnInit {

  centerLat = 24.8174254;
  centerLng = 67.000104;
  public apptext2: string;
  public filterdata = [];
  infoWindowOpened = null
  apptext: string;
  category: string;
  branches: string;
  industries: string;
  public events: any = {};
  public zoom = 11;
  public mapStyles;
  public Lat: number;
  public Long: number;
  public Branch_name: string;
  public Branch_address: string;
  public branch_phone: string;
  public branch_fax: string;
  public iconpath = "assets/images/meezan.png";
  public iconpathC = "assets/images/Competitor.png";
  public iconpathClient = "assets/images/client.png";
  public mz = [];
  public mzMulti = [];
  isLoad = true;

  public POI = [];
  industriesTooltip: string;
  branchesTooltip: string;
  meezanbCount = 'Meezan Branches';
  compCount = 'Competitors';
  bCount = 'Industries';
  cCount = 'Existing Clients';
  public dataaa;
  public color = "blue";
  public bid = "";
  public dt = [];
  public clientMarkers = [];
  public tary;
  public me;
  public arr;
  public istrue = true;
  public clorblue = [];
  public clorred = [];
  public clorgreen = [];
  selectedEntry;
  entries =  [ {id: 1, description: 'Industries', class : 'spanBlue'},{id: 2, description: 'Competitors',class : 'spanRed'}, {id: 3,description: 'Existing Clients',class : 'spanGreen'}];
  


  constructor(private router: Router, public Service: SalesService, private config: Configuration) {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
  }


  ngOnInit() {

   

    if (!!localStorage.getItem('User') == true) {
      if (!!localStorage.getItem('data') == true) {

        let branch = JSON.parse(localStorage.getItem('data'));
        this.category = '';
        this.industries = '';

        branch.builtinCat.map(d => {
          this.category = this.category + ' , ' + d.value
        })
        this.category = this.category.substr(2);

        if (branch.categorymap.length == branch.sectionCount) {
          this.industries = 'ALL';
        }
        else {
          branch.categorymap.map(d => {
            this.industries = this.industries + ' , ' + d
          })

          this.industries = this.industries.substr(2);
          this.industriesTooltip = this.industries;
        }
        if (this.industries.length > 40) {
          this.industries = this.industries.substr(0, 40);
        }

        this.mapStyles = branch.builtinCat.filter(x => x.checked == false).map(x => x.list);

      }
      else { alert('Please select branch and section!'); }

    }
    else { this.router.navigate(['/login']); }

  }


  clickedMarker(infoWindow, index: number) {
    if (this.infoWindowOpened === infoWindow)
      return;

    if (this.infoWindowOpened !== null)
      this.infoWindowOpened.close();

    this.infoWindowOpened = infoWindow;
    this.zoom = 14
  }

  public branch_latitude;
  public branch_longitude;

  clickedMarkerB(infoWindow, index: number, mId, lt, lg) {
    this.isLoad = false;
    let data = JSON.parse(localStorage.getItem('data'));
    if (data.compet == false) {
      this.istrue = false;
    }
    this.branch_latitude =""; this.branch_longitude = "";
    this.filterdata = [];
    this.POI = [];
    this.clientMarkers = [];

    if (this.infoWindowOpened !== null) { this.infoWindowOpened.close(); }
    this.infoWindowOpened = infoWindow;
    this.bid = mId;
    this.events.getBranchData = this.Service.getBranchData(mId.toString(), "ALL").subscribe(result => {
     let t = result[0]['Branches'];
    //  console.log(t)
     this.branch_latitude = t[0]['branch_latitude'];this.branch_longitude = t[0]['branch_longitude'];
      this.clorblue = result[1]['Sections'];
      this.clorred = result[2]['Class'];
      this.clorgreen  = result[3]['ExistingClients'];
        if(this.selectedEntry == 2)
        {  
           this.POI = this.clorred 
      }
      if(this.selectedEntry == 1 || this.selectedEntry == undefined)
      {
        this.filterdata = this.clorblue
      }
      if(this.selectedEntry == 3)
      {
      this.clientMarkers  = this.clorgreen
      }
      this.centerLat = this.ConvertString(lt);
      this.centerLng = this.ConvertString(lg);
      this.zoom = 14;
      this.isLoad = true;
    })

   
  }
 
  clickedMarkerBM(infoWindow, index: number) {
    if (this.infoWindowOpened === infoWindow)
      return;
    if (this.infoWindowOpened !== null)
      this.infoWindowOpened.close();
    this.infoWindowOpened = infoWindow;
    this.zoom = 14
  }

  clickedMarkerC(infoWindow, ) {
    if (this.infoWindowOpened === infoWindow)
      return;
    if (this.infoWindowOpened !== null)
      this.infoWindowOpened.close();
    this.infoWindowOpened = infoWindow;
    this.zoom = 14
  }

  ConvertString(value) {
    return parseFloat(value)
  }



  onSelectionChange(entry) {
    let data = JSON.parse(localStorage.getItem('data'));
    this.selectedEntry = entry.id;
    if (entry.id == 1) {
      this.color = "blue";
      this.filterdata = this.clorblue;
      this.clientMarkers = [];
      this.POI = [];

    }
    if (entry.id == 2) {
      if (data.compet == true) {
        this.POI = this.clorred;
      }
      this.color = "red";
      
      this.filterdata = [];
      this.clientMarkers = [];
    }
    if (entry.id == 3) {
      this.color = "green";
      this.clientMarkers = this.clorgreen;
      this.filterdata = [];
      this.POI = [];
    }
  }

  fetchData() {
    this.isLoad = false;
    let data = JSON.parse(localStorage.getItem('data'));
    let dtaa = [];
    let bId = data.branch;
    let bIdStr = "";
    if (bId.length == data.branchCount) { bIdStr = "ALL" }
    else {
      bId.map(w => {
        bIdStr = bIdStr + "," + w
      })
      bIdStr = bIdStr.substr(1);
    }

    let ct = data.categorymap;
    let ctname = "";
    if (ct.length == data.sectionCount) {
      ctname = "ALL"
    }
    else {
      ct.map(w => {
        ctname = ctname + "," + w
      })
      ctname = ctname.substr(1);
    }

  
    if (bIdStr == "ALL") {
      this.events.getBranchData = this.Service.getALLBranch().subscribe(result => {
        this.mz = result[0]['Branches'];
        console.log(this.mz.length);
        this.branches = 'ALL';
        this.isLoad = true;
      });
    }
    else {

      this.events.getBranchData = this.Service.getBranchData(bIdStr, ctname).subscribe(result => {
        this.filterdata =[];
        this.mzMulti = result[0]['Branches'];
        this.filterdata = result[1]['Sections'];
        if (data.compet == true) {
          this.POI = result[2]['Class'];
        }
        this.clientMarkers = result[3]['ExistingClients'];
        this.compCount = this.compCount + ' : ' + (this.POI.length);
        this.meezanbCount = this.meezanbCount + ' : ' + this.mzMulti.length;
        this.bCount = this.bCount + ' : ' + this.filterdata.length;
        this.cCount = this.cCount + ' : ' + this.clientMarkers.length;
        if (this.mzMulti.length == data.branchCount) {
          this.branches = 'ALL';
        }
        else {
          this.branches = '';
          this.mzMulti.map(d => {
            this.branches = this.branches + ' , ' + d.branch_name;
          })

          this.branches = this.branches.substr(2);
          this.branchesTooltip = this.branches;
        }
        if (this.branches.length > 40) {
          this.branches = this.branches.substr(0, 40);
        }
        this.isLoad = true;
      })
    }


  }



  exportPDF() {
    this.isLoad = false;
    var pdfData = [[{ text: 'Name', bold: true }, { text: 'Address', bold: true },
    { text: 'Telephone', bold: true }, { text: 'Industry', bold: true }]];
    let branch = JSON.parse(localStorage.getItem('data'));
    var bId = branch.branch.toString();
    var ct = branch.categorymap[0];

    this.filterdata.map(d => {
      let arrt = [];
      arrt.push(d.Name);
      arrt.push(d.Address);
      arrt.push(d.Telephone);
      arrt.push(d.Section);
      pdfData.push(arrt);
      this.isLoad = true;
    });

    this.pdfGenerate(pdfData);
  }

  pdfGenerate(data) {
    var docDefinition = {
      pageMargins: [15, 50, 15, 40],
      content: [
        {
          layout: 'lightHorizontalLines', // optional
          table: {
            // headers are automatically repeated if the table spans over multiple pages
            // you can declare how many rows should be treated as headers
            headerRows: 1,
            widths: ['*', 'auto', 100, '*'],
            body: data
          }
        }
      ],
      header: {
        margin: 10,
        columns: [
          {
            margin: [5, 20, 0, 0],
            text: 'Branch Name : ' + this.branches
          },
          {
            margin: [0, 0, 0, 0],
            text: 'Buisness Details',
            fontSize: 14,
          },
          {
            image: 'data:image/png;base64,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',
            width: 60
          },
        ]
      },
      footer: function (currentPage, pageCount) {
        return {
          columns: [
            "Page: " + currentPage.toString() + ' of ' + pageCount,
            {
              text: 'Selected businesses are within 5 kilometers range of the branch',
              alignment: 'center',
              fontSize: 6
            },
            {
              text: moment(Date.now(), 'x').format('MM/DD/YYYY'),
              alignment: 'right'
            }
          ],
          margin: [25, 10, 25, 0],
          fontSize: 8
        }
      },
      styles: {
        header: {
          bold: true,
          alignment: 'justify',
          margin: [0, 40, 0, 40]
        },
        table: {
          margin: [0, 40, 0, 0]
        },
        money: {
          alignment: 'right'
        },
        tableHeader: {
          bold: true
        },
        tableHeaderRight: {
          alignment: 'right',
          bold: true
        }
      },
      tableLayouts: {
        accounting: {
          hLineWidth: function (i, node) {
            return .5;
          },
          vLineWidth: function (i, node) {
            return 0;
          },
          hLineColor: function (i, node) {
            return i === (node.table.body.length - 1) ? 'gray' : 'white';
          },
          vLineColor: function (i, node) {
            return 'white';
          }
        }
      },
      defaultStyle: {
        fontSize: 8,
      }
    };

    pdfMake.createPdf(docDefinition).open();
  }

  mapReady($event: any) {
    this.getLatLong($event, null);
  }


  refreshMap() {
    this.isLoad = false;
    this.zoom = 11;
    if(this.branches == 'ALL')
    {
      
      this.clientMarkers = [];
      this.POI = [];
      this.filterdata = [];
      if (this.infoWindowOpened !== null)
        this.infoWindowOpened.close();
      }
      this.isLoad = true;
      this.branch_latitude = '';
      this.branch_longitude = '';
  }


  getLatLong(map: any, fn) {
    let data = JSON.parse(localStorage.getItem('data'));
    this.fetchData();
    // this.isLoad = false;
    if (data.branch.length == data.branchCount) {
      if (data.compet == false) {
        this.entries = [ {id: 1, description: 'Industries', class : 'spanBlue'},{id: 3,description: 'Existing Clients', class : 'spanGreen'}];
      }
      else
      {this.entries = [ {id: 1, description: 'Industries', class : 'spanBlue'},{id: 2, description: 'Competitors',class : 'spanRed'}, {id: 3,description: 'Existing Clients',class : 'spanGreen'}];}
      map.controls[google.maps.ControlPosition.TOP_RIGHT].push(document.getElementById('mapRefresh'));
    
      // this.isLoad = true;
    }
    else {
      if (data.compet == false) {
        // this.istrue = false;
      }
      map.controls[google.maps.ControlPosition.TOP_RIGHT].push(document.getElementById('mapLabels'));
    
      this.isLoad = true;
    }
    map.controls[google.maps.ControlPosition.TOP_LEFT].push(document.getElementById('mapRefreshBtn'));
  }

}





// WEBPACK FOOTER //
// ./src/app/home-page/store-view/store-view.component.ts